import React, { useState } from 'react';
interface FormData {
  nombre: string;
  email: string;
  telefono: string;
}
export function Mapa2Page() {
  const [formData, setFormData] = useState<FormData>({
    nombre: '',
    email: '',
    telefono: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <main className="min-h-screen w-full bg-gray-50 flex items-center justify-center px-4 py-16" data-id="element-190">
      <div className="w-full max-w-md" data-id="element-191">
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8" data-id="element-192">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-2" data-id="element-193">
            Contáctanos
          </h1>
          <p className="text-gray-500 text-center mb-8" data-id="element-194">
            Déjanos tus datos y te contactaremos pronto.
          </p>

          {submitted ? <div className="text-center py-8 space-y-4" data-id="element-195">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto" data-id="element-196">
                <svg className="w-8 h-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-197">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-198" />
                </svg>
              </div>
              <p className="text-xl font-semibold text-gray-900" data-id="element-199">
                ¡Datos enviados!
              </p>
              <p className="text-gray-500" data-id="element-200">
                Gracias, {formData.nombre}. Nos pondremos en contacto contigo
                pronto.
              </p>
            </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-201">
              <div data-id="element-202">
                <label htmlFor="nombre" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-203">
                  Nombre
                </label>
                <input type="text" id="nombre" name="nombre" required value={formData.nombre} onChange={handleChange} placeholder="Tu nombre" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#D90B10] focus:border-transparent outline-none transition-all text-gray-900 placeholder-gray-400" data-id="element-204" />
              </div>

              <div data-id="element-205">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-206">
                  Email
                </label>
                <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} placeholder="tu@email.com" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#D90B10] focus:border-transparent outline-none transition-all text-gray-900 placeholder-gray-400" data-id="element-207" />
              </div>

              <div data-id="element-208">
                <label htmlFor="telefono" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-209">
                  Teléfono
                </label>
                <input type="tel" id="telefono" name="telefono" required value={formData.telefono} onChange={handleChange} placeholder="+1 234 567 8900" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#D90B10] focus:border-transparent outline-none transition-all text-gray-900 placeholder-gray-400" data-id="element-210" />
              </div>

              <button type="submit" className="w-full bg-[#D90B10] hover:bg-[#c00a0e] text-white font-bold py-4 px-8 rounded-lg text-lg transition-colors shadow-lg mt-2" data-id="element-211">
                Enviar
              </button>
            </form>}
        </div>
      </div>
    </main>;
}